import * as React from 'react';

import { State } from '~/store/types';
import connect from '~/store/connect';
import { ResidentConfigurationForm } from './ResidentConfigForm';
import { ResidentConfigDetail } from './ResidentConfigDetail';
import { Spinner } from '@ixicare/ui';
import { t } from '~i18n';
import { Permission } from '@ixicare/resources';

interface ResidentSettingsContainerProps {
  profile: State['residentDetail']['profile'];
  adminPermissions?: boolean;
}

const ResidentSettingsContainer: React.FC<ResidentSettingsContainerProps> = ({ profile }) => {
  const [configurationPermission, setConfigurationPermission] = React.useState<boolean>();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    Permission.getOwnPermissions().then((value) => {
      if (value.length != 0) {
        value[0].entries.find((perm) => {
          if (perm.permission.name.includes('can_edit_all_profiles')) {
            if (perm.isEnabled) {
              setConfigurationPermission(true);
            }
          }
        });
      }
      setIsLoading(false);
    });
  }, []);

  if (isLoading) {
    return <Spinner label={t('global.loading')} />;
  }

  return (
    <>
      {profile && configurationPermission ? (
        <ResidentConfigurationForm profile={profile} />
      ) : (
        profile && <ResidentConfigDetail profile={profile} />
      )}
    </>
  );
};

export default connect((state: State) => ({
  profile: state.residentDetail.profile,
}))(ResidentSettingsContainer);
